import React from 'react';
import { Reveal } from './Reveal';
const pains = ['Domingo a la noche pensando en todo lo que no hiciste con ellos esta semana', 'Decirles “ahora no puedo” y ver la cara que ponen', 'Llegar a casa sin energía para inventar algo que hacer juntos', 'Comparar tu semana con la de otros padres que “parecen” más presentes en redes', 'Fines de semana que se van en trámites, pantallas y descanso, sin un momento real de conexión', 'El mismo ciclo de culpa, cada semana, sin que nada cambie'];
export function PainSection() {
  return <section aria-label="El problema" className="w-full bg-cream-200 py-16 sm:py-24" data-id="element-119" data-mp="2q0dl9fah7zho">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-120" data-mp="2bbr89k8bnjtm">
        <Reveal data-id="element-121" data-mp="2g8pyvsss18n2">
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-bark-900 sm:text-4xl" data-id="element-122" data-mp="2gaau7kmx0vlz">
            ¿Cuántas noches más te vas a acostar pensando que no fue suficiente?
          </h2>
        </Reveal>

        <Reveal delay={0.05} data-id="element-123" data-mp="277rs52qyen0s">
          <p className="mt-6 text-base leading-relaxed text-bark-600 sm:text-lg" data-id="element-124" data-mp="3rn0s3fchsk4j">
            Sos un padre o una madre que trabaja duro. Amás a tus hijos más que a nada. Pero nadie te
            dijo que ibas a llegar a casa agotado, con la cabeza en el trabajo, y la sensación de que
            el día se te escapó sin haber estado ahí de verdad.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-125" data-mp="emwqmzar42o">
          <p className="mt-6 font-display text-xl font-semibold text-terracotta-600 sm:text-2xl" data-id="element-126" data-mp="38w9mmovmldvf">
            No es falta de amor. Es falta de un sistema.
          </p>
        </Reveal>

        <ul className="mt-9 space-y-3" data-id="element-127" data-mp="3imcgerakmvut">
          {pains.map((pain, i) => <Reveal key={pain} delay={0.04 * i} data-id="element-128" data-mp="3iofgk45fu5d9" data-mpi={i}>
              <li className="flex items-start gap-3 rounded-2xl bg-cream-50 px-5 py-4 text-[0.95rem] leading-relaxed text-bark-600 shadow-sm sm:text-base" data-id="element-129" data-mp="3dvcgrea2hzom">
                <span aria-hidden="true" className="mt-0.5 shrink-0" data-id="element-130" data-mp="2q3oy1jmyluxf">
                  ❌
                </span>
                <span data-id="element-131" data-mp="p3tsvnbiov55">{pain}</span>
              </li>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-132" data-mp="u2wz3b38h7ep">
          <p className="mt-10 text-center font-display text-2xl font-semibold italic text-bark-900 sm:text-3xl" data-id="element-133" data-mp="u23ou052fzrt">
            ¿Y si esta fuera la última semana que pasás así?
          </p>
        </Reveal>
      </div>
    </section>;
}